import { formatDate } from '../../../../lib/utils';

const LogItem = ({ date, waistHips, armThigh, onClick }) => {
  return (
    <div className='space-y-2 text-xs'>
      <div className='font-bold text-white'>{formatDate(new Date(date))}</div>
      <div className='space-y-1'>
        <table className='w-full text-sm rounded-t-lg overflow-hidden'>
          <thead className='bg-secondary'>
            <tr>
              {waistHips.headers.map((header) => (
                <th
                  key={header}
                  className='px-4 py-3 text-center font-medium text-white'
                >
                  {header}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {waistHips.bodies.map((body, i) => (
              <tr
                key={i}
                className='border-b border-tertiary cursor-pointer hover:bg-tertiary/30 transition-colors'
                onClick={onClick}
              >
                {body.map((value, k) => (
                  <td
                    key={k}
                    className='px-2 py-3 text-center text-white'
                  >
                    {value} cm
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
        <table className='w-full text-sm overflow-hidden'>
          <thead className='bg-secondary'>
            <tr>
              {armThigh.headers.map((header, i) => (
                <th
                  key={header}
                  className='px-4 py-3 text-center font-medium text-white'
                >
                  {header}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {armThigh.bodies.map((body, i) => (
              <tr
                key={i}
                className='border-b border-tertiary cursor-pointer hover:bg-tertiary/30 transition-colors'
                onClick={onClick}
              >
                {body.map((value, k) => (
                  <td
                    key={k}
                    className='px-2 py-3 text-center text-white'
                  >
                    {value} {value !== '-' && 'cm'}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default LogItem;
